import React, { useState } from "react"
import { Layout, Modal, Title } from "../components/index"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { imagesGrid, imageWrap } from "./worktemplate.module.scss"

import { motion } from "framer-motion"

const WorkTemplate = ({ data }) => {
  const { title, gallery } = data.work

  const [selectedImg, setSelectedImg] = useState(null)
  return (
    <Layout>
      <section>
        <Title title={title} />
        <ImageGrid gallery={gallery} setSelectedImg={setSelectedImg} />
        {selectedImg ? (
          <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
        ) : null}
      </section>
    </Layout>
  )
}

const ImageGrid = ({ gallery, setSelectedImg }) => {
  const images = gallery.map(image => {
    return (
      <motion.div
        className={imageWrap}
        key={image.hash}
        onClick={() => setSelectedImg(image)}
        whileHover={{ opacity: 0.8, transform: "translate" }}
        layout
      >
        <Img
          fluid={image.localFile.childImageSharp.fluid}
          objectFit="contain"
        />
      </motion.div>
    )
  })

  return <div className={imagesGrid}>{images}</div>
}

export const query = graphql`
  query GetSingleWork($slug: String) {
    work: strapiWork(slug: { eq: $slug }) {
      title
      gallery {
        localFile {
          childImageSharp {
            fluid(quality: 100) {
              src
              ...GatsbyImageSharpFluid
              ...GatsbyImageSharpFluidLimitPresentationSize
            }
          }
        }
        url
      }
      completed
    }
  }
`

export default WorkTemplate
